class subscriptionWidget extends HTMLElement {
  constructor() {
    super();

    const purchaseWrapper = this.querySelector(".purchase_options_wrapper");
    const productInfoContainer = this.closest(".product__info-container");
    const sellingPlanInput = this.querySelector('[name="selling_plan"]');
    const sellingPlanSelectors = this.querySelectorAll(
      ".selling_plan_selector",
    );

    const dispatchSellingPlanChange = (sellingPlanId) => {
      this.dispatchEvent(
        new CustomEvent("selling-plan:change", {
          bubbles: true,
          detail: { sellingPlanId: sellingPlanId || null },
        }),
      );
    };

    purchaseWrapper?.addEventListener("click", (e) => {
      const target = e.target.closest(".subscribe_and_save_widget, .one_time");
      if (!target) return;

      if (target.classList.contains("subscribe_and_save_widget")) {
        const selectedPlan = document.querySelector('.live_region--variant-subscription select').value
        
        if (selectedPlan && sellingPlanInput) {
          sellingPlanInput.value = selectedPlan;
        }
        purchaseWrapper.setAttribute(
          "data-purchase-option",
          "subscribe_and_save",
        );
        productInfoContainer.setAttribute(
          "data-purchase-option",
          "subscribe_and_save",
        );
        
        dispatchSellingPlanChange(selectedPlan);

      } else if (target.classList.contains("one_time")) {
        if (sellingPlanInput) {
          sellingPlanInput.value = "";
        }
        purchaseWrapper.setAttribute("data-purchase-option", "one_time");
        productInfoContainer.setAttribute("data-purchase-option", "one_time");
        dispatchSellingPlanChange("");
      }
    });

    // Sync all selling plan selectors
    sellingPlanSelectors.forEach((selector) => {
      selector.addEventListener("change", (e) => {
        const newValue = e.target.value;

        // Update all other selectors and the hidden input
        sellingPlanSelectors.forEach((otherSelector) => {
          if (otherSelector !== e.target) {
            otherSelector.value = newValue;
          }
        });

        if (sellingPlanInput) {
          sellingPlanInput.value = newValue;
        }

        dispatchSellingPlanChange(newValue);
      });
    });
  }
}

customElements.define("subscription-widget", subscriptionWidget);